import Header from './Header';

const Layout = {
    Header
}

export default Layout;